function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.object.define-properties.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import mixinActionBoxStyles from './mixinActionBoxStyles';
export default {
  name: 'CoreHeader',
  mixins: [mixinActionBoxStyles],
  props: {
    headerBG: {
      type: String,
      required: false,
      "default": null
    },
    headline: {
      type: String,
      "default": '',
      required: false
    },
    subtitle: {
      type: String,
      required: false,
      "default": function _default() {
        return null;
      }
    },
    loader: {
      type: Boolean,
      required: false,
      "default": false
    },
    isLoading: {
      type: Boolean,
      required: false,
      "default": false
    },
    isSaving: {
      type: Boolean,
      required: false,
      "default": false
    },
    formIsValid: {
      type: Boolean,
      required: false,
      "default": false
    },
    cancelButton: {
      type: Boolean,
      required: false,
      "default": false
    },
    saveButton: {
      type: Boolean,
      required: false,
      "default": false
    },
    buttons: {
      type: Array,
      required: false,
      "default": function _default() {
        return null;
      }
    },
    templateContext: {
      type: Boolean,
      required: false,
      "default": false
    },
    isProductiveVersion: {
      type: Boolean,
      required: false,
      "default": false
    },
    hasUnsyncedChanges: {
      type: Boolean,
      required: false,
      "default": false
    },
    itemIsChanged: {
      type: Boolean,
      required: false,
      "default": false
    },
    showBetaBadge: {
      type: [Boolean, String],
      required: false,
      "default": function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      pageYOffset: 0,
      validStates: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled'])), {}, {
    styles: function styles() {
      var width = 0;
      if (!this.saveButton && !this.cancelButton) {
        var _width = 10;
        return {
          width: 'fit-content',
          'max-width': "calc(100% - ".concat(_width, "px)")
        };
      }
      if (this.saveButton) {
        width = width + 165;
      }
      if (this.cancelButton) {
        width = width + 65;
      }
      return {
        'max-width': "calc(100% - ".concat(width, "px)"),
        width: 'fit-content'
      };
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    cloading: function cloading() {
      return this.$store.state.app.loading;
    },
    displayButtons: function displayButtons() {
      if (this.buttons) {
        return this.buttons;
      }
      var buttons = [];
      if (this.saveButton) {
        buttons.push({
          icon: 'fas fa-save',
          title: this.$i18n_t('Common.save'),
          disabled: this.templateContext && this.isProductiveVersion,
          type: 'submit',
          action: 'saveData'
        });
      }
      if (this.cancelButton) {
        buttons.push({
          icon: 'fal fa-times',
          color: 'danger',
          disabled: this.templateContext && this.isProductiveVersion,
          action: 'cancel',
          tooltip: this.$i18n_t('Common.cancel')
        });
      }
      return buttons.length ? buttons : null;
    }
  }),
  watch: {
    displayButtons: {
      handler: function handler(newV) {
        this.validStates = (newV || []).map(function (button) {
          return button.valid === undefined || button.valid;
        });
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.validStates = (this.displayButtons || []).map(function (button) {
      return button.valid === undefined || button.valid;
    });
    window.addEventListener('scroll', this.saveScrollOffset);
    this.actionBoxIsFixed = !this.headerBG && !this.headline && this.subtitle && !this.$slots['headline'];
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.saveScrollOffset);
  },
  methods: {
    buttonHasValidState: function buttonHasValidState(i) {
      if (i < this.validStates.length) {
        return this.validStates[i];
      }
      return true;
    },
    saveScrollOffset: function saveScrollOffset() {
      this.pageYOffset = window.pageYOffset;
    },
    handleButtonClick: function handleButtonClick(buttonDefinition) {
      if (!buttonDefinition) {
        return;
      }
      if (buttonDefinition.action) {
        this.$emit(buttonDefinition.action);
      }
      if (buttonDefinition.onClick) {
        buttonDefinition.onClick();
      }
    }
  }
};